
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { State } from '../../models/state.model';
import { AuthService } from '../../services/auth.service';
import { StateService } from '../../services/state.service';
import { LanguageService } from '../../services/language.service';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AppState } from 'src/app/store/app.state';
import { Subscription, filter, fromEvent, map, merge, of } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent, IConfirmDialogModel } from 'src/app/shared/components/dialogs';
import { MainHubService } from 'src/app/services/mainHubService.service';
import { TranslateService } from '@ngx-translate/core';
import { SsoService } from '../../services/sso.service';

@UntilDestroy()
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {    
    public state: State;            
    public showHeader = false;
    public isLoginPage = false;

    public year = (new Date()).getFullYear();

    networkStatus: boolean = false;
    networkStatus$: Subscription = Subscription.EMPTY;

    public connectionDialog: MatDialogRef<ConfirmDialogComponent, any>;

    // not stored in history
    public readonly excludedUrls = [
        'login', 'company/create', 'employee-add', 'assessment/', 'goal-basic-settings'
    ];

    constructor(
        public appState: AppState,
        private authService: AuthService,
        private mainHubService: MainHubService,
        public stateService: StateService,
        private router: Router,
        private matIconRegistry: MatIconRegistry,

        private dialog: MatDialog,
        private languageService: LanguageService,
        private translate: TranslateService,
        private ssoService: SsoService
    ) {
        this.state = stateService.state;
        
        // Language initialization
        this.languageService.initializeLanguage();
        
        this.manageIcons();
    }

    ngAfterViewInit(): void {
        document.addEventListener('touchstart', () => {}, { passive: true });
    }

    ngOnInit() {
        //console.log('App component init...');
        this.ssoService.init();

        this.storeRouteHistory();
               
        this.router.events
        .pipe(
            filter(event => event instanceof NavigationEnd),
            untilDestroyed(this)
        )
        .subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.isLoginPage = this.router.url.includes('login');
                this.storeRouteHistory();

                this.showHeader = !this.isLoginPage;
            }
        });
        
        this.checkNetworkStatus();

        this.stateService.state.me.obs$.subscribe(user => {
            if (user) {
                this.mainHubService.startConnection();
            } else {
                this.mainHubService.stopConnection();
            }
        });

        // SSO Debugging
        // this.appState.iframeLoginMode.obs$.pipe(untilDestroyed(this)).subscribe(val => {
        //     console.log('AppComponent: iframeLoginMode changed:', val);
        // });
        // this.appState.ssoStatus.obs$.pipe(untilDestroyed(this)).subscribe(val => {
        //     console.log('AppComponent: ssoStatus changed:', val);
        // });
    }

    ngOnDestroy(): void {
        this.networkStatus$.unsubscribe();
        this.mainHubService.stopConnection();
    }



    inExcludedUrls(url: string): boolean {

        for (const element of this.excludedUrls) {
            if (url.includes(element))
                return true;
        }
        
        return false;
    }

    storeRouteHistory() {
        this.appState.prevLocation.value = this.appState.currentLocation.value;

        if (!this.inExcludedUrls(this.router.url) && this.appState.currentLocation.value != this.router.url)
            this.appState.currentLocation.value = this.router.url;
    }

    manageIcons() {
        // this.matIconRegistry.addSvgIcon(
        //     "user-identity",
        //     this.domSanitizer.bypassSecurityTrustResourceUrl("../../../assets/svg/user-identity.svg")
        //   );
    }

    checkNetworkStatus() {
        this.networkStatus = navigator.onLine;
        this.networkStatus$ = merge(
          of(null),
          fromEvent(window, 'online'),
          fromEvent(window, 'offline')
        )
          .pipe(map(() => navigator.onLine))
          .subscribe(status => {
            console.log('status:', (status ? 'online' : 'offline'));            
            this.networkStatus = status;

            if (!status)
                this.showConnectionDialog();
            else
                this.closeConnectionDialog();
          });
    }

    showConnectionDialog() {        
        this.connectionDialog = this.dialog.open(ConfirmDialogComponent, {
            maxWidth: "400px",
            data: {
                title: 'Kapcsolódási hiba',
                message: `Megszűnt az internet kapcsolat. Kérjük ellenőrizze a hálózati beállításokat.`,
                showCancel: false
            } as IConfirmDialogModel
          });
    }

    closeConnectionDialog(){
        if (this.connectionDialog)
            this.connectionDialog.close();
    }
}
